export default "__VITE_ASSET__BDHKZXzI__"